import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export function Logo({ dark = false, className = "" }) {
  return (
    <Link to="/" data-testid="logo-link" className={"flex items-center group " + className}>
      <img
        src={dark ? "/logo-white.png" : "/logo.png"}
        alt="AM-Montage – Fenster & Sonnenschutz"
        className="h-12 md:h-14 w-auto object-contain"
      />
    </Link>
  );
}

export function LanguageSwitcher({ light = false }) {
  const { lang, changeLang } = useApp();
  const langs = ["de", "sl", "hr"];
  return (
    <div className="flex items-center gap-0.5" data-testid="language-switcher">
      {langs.map((l, i) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => changeLang(l)}
          className={`px-2 py-1 text-xs font-semibold uppercase tracking-wider transition-colors ${
            lang === l ? (light ? "text-white" : "text-accent2") : light ? "text-white/40 hover:text-white/70" : "text-slate-400 hover:text-brand"
          }`}
        >
          {l}
        </button>
      )).reduce((acc, el, i) => i === 0 ? [el] : [...acc, <span key={"s"+i} className={light ? "text-white/20" : "text-slate-300"}>/</span>, el], [])}
    </div>
  );
}
